import { HttpClientModule } from '@angular/common/http';
import { ApolloModule } from 'apollo-angular';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
//import { HttpLinkModule } from 'apollo-angular-link-http';

import { AuthGuard } from 'app/backend/auth.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { BackendModule } from './backend/backend.module';
import { NTCRegisterComponent } from './ntc/ntc-register.component';
import { RootModule } from './root/root.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    NTCRegisterComponent,
  ],
  imports: [
    SharedModule,
    AppRoutingModule,
    RootModule,
    BackendModule,
    BrowserModule,
    HttpClientModule,
    ApolloModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot()
  ],
  providers: [
    AuthGuard
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
